import React, {useState} from "react";
import {useModalStatus} from "./modal_status_hook";

const DishContext = React.createContext(null);

function useDishContextValue() {
    const [inputDishName, setInputDishName] = useState('');
    const [inputDishDescription, setInputDishDescription] = useState('');
    const [dish, setDish] = useState(null);
    const [offData, setOffData] = useState(null);
    const [tabelogUrl, setTabelogUrl] = useState('');
    const [tabelogData, setTabelogData] = useState(null);
    const [gs1Data, setGs1Data] = useState(null);
    const [allergens, setAllergens] = useState([]);
    const [diets, setDiets] = useState([]);
    const [impact, setImpact] = useState(null);
    const [barcode, setBarcode] = useState(null);
    const [filteredAllergies, setFilteredAllergies] = useState([]);
    const [filteredDiets, setFilteredDiets] = useState([]);

    const [aiDishDescriptionModalStatus, openAiDishDescriptionModal, closeAiDishDescriptionModal] = useModalStatus();
    const [weightModalStatus, openWeightModal, closeWeightModal] = useModalStatus();
    const [nutritionalModalStatus, openNutritionalModal, closeNutritionalModal] = useModalStatus();
    const [dishesModalStatus, openDishesModal, closeDishesModal] = useModalStatus();

    const updateIngredients = (ingredients) => {
        setDish({
            ...dish,
            ingredients: [...ingredients]
        });
    }

    const getDishWeight = React.useCallback(() => {
        const ingredients = Array.isArray(dish?.ingredients) ? dish.ingredients : (dish?.ingredients?.ingredients || []);
        if (dish && Array.isArray(ingredients)) {
            let sum = 0;
            const finalSum = ingredients.reduce((prev, ingredient) => {
                if (ingredient.weight)
                    return parseFloat(prev) + parseFloat(ingredient.weight)
                else return parseFloat(prev);
            }, sum);
            return finalSum;
        } else return 0;
    }, [dish]);

    const ingredients_weight = getDishWeight();

    return React.useMemo(() => {
        return {
            dish,
            setDish,
            updateIngredients,
            ingredients_weight,
            diets,
            setDiets,
            getDishWeight,
            allergens,
            setAllergens,
            impact,
            setImpact,
            weightModalStatus,
            openWeightModal,
            closeWeightModal,
            nutritionalModalStatus,
            openNutritionalModal,
            closeNutritionalModal,
            offData,
            setOffData,
            barcode,
            setBarcode,
            filteredAllergies,
            setFilteredAllergies,
            filteredDiets,
            setFilteredDiets,
            aiDishDescriptionModalStatus,
            openAiDishDescriptionModal,
            closeAiDishDescriptionModal,
            dishesModalStatus,
            openDishesModal,
            closeDishesModal,
            inputDishName, setInputDishName,
            inputDishDescription, setInputDishDescription,
            gs1Data, setGs1Data,
            tabelogData, setTabelogData,
            tabelogUrl, setTabelogUrl,
        }
    }, [
        dish, setDish, updateIngredients,
        diets, setDiets, getDishWeight,
        allergens, setAllergens,
        impact, setImpact,
        weightModalStatus, openWeightModal, closeWeightModal,
        nutritionalModalStatus, openNutritionalModal, closeNutritionalModal, offData, setOffData,
        barcode, setBarcode, filteredAllergies, setFilteredAllergies, filteredDiets, setFilteredDiets,
        aiDishDescriptionModalStatus,
        openAiDishDescriptionModal,
        closeAiDishDescriptionModal,
        dishesModalStatus,
        openDishesModal,
        closeDishesModal,
        inputDishName, setInputDishName,
        inputDishDescription, setInputDishDescription,
        gs1Data, setGs1Data,
        tabelogData, setTabelogData,
        tabelogUrl, setTabelogUrl,
    ])

}

function DishProvider({...props}) {
    const value = useDishContextValue();
    return <DishContext.Provider value={value} {...props}>{props.children}</DishContext.Provider>
}

function useDish() {
    const context = React.useContext(DishContext);
    if (!context) throw new Error('useDish must be used within a DishProvider');
    return context;
}

export {
    useDish,
    DishProvider,
}
